import React from 'react'
import '../styles/layout/Services.css'
import { Container } from 'react-bootstrap';
import CardArt from './CardArt'
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import PaymentsIcon from '@mui/icons-material/Payments';
import AddCardIcon from '@mui/icons-material/AddCard';
import MoneyIcon from '@mui/icons-material/Money';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import ViewDayIcon from '@mui/icons-material/ViewDay';
// Filled glyphs throughout. The line-art ones (a fish hook for fraud, a thin
// headset for queries) carried so little ink that the last rows of the list
// looked faded next to the solid card icons above them.
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

const SERVICES = [
  { Icon: CreditCardIcon, title: 'Credit Card Design & Onboarding' },
  { Icon: CreditScoreIcon, title: 'Credit Card Authorization' },
  { Icon: PaymentsIcon, title: 'Payment Processing' },
  { Icon: AddCardIcon, title: 'Rewards Program Management' },
  { Icon: MoneyIcon, title: 'Customer Billing' },
  { Icon: CollectionsBookmarkIcon, title: 'Collections & Dispute Resolutions' },
  { Icon: ViewDayIcon, title: 'Credit Card Risk Management' },
  { Icon: GppMaybeIcon, title: 'Credit Card Fraud Detection' },
  { Icon: HeadsetMicIcon, title: 'Customer Query Resolution' },
]

const ServiceList = () => {
  return (
    <section className='serviceList section section--defer section--soft section--divide'>
      <span className="aurora aurora--low" aria-hidden="true" />
      <Container>
        <div className="svcSplit">
          <div className="svcSplit__visual reveal reveal--scale">
            <CardArt />
          </div>

          {/* The list reveals as one block. Revealing each row separately gave
              every row its own scroll timeline, so at any scroll position the
              lower rows were earlier in their animation and the list visibly
              faded out towards the bottom. */}
          <ul className="svcSplit__list reveal">
            {SERVICES.map(({ Icon, title }) => (
              <li className="svcRow" key={title}>
                <span className="svcRow__icon" aria-hidden="true"><Icon /></span>
                <h5>{title}</h5>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  )
}

export default ServiceList
